import { render, staticRenderFns } from "./tabSelectNew.vue?vue&type=template&id=2f8c8d92"
import script from "./tabSelectNew.vue?vue&type=script&lang=js"
export * from "./tabSelectNew.vue?vue&type=script&lang=js"
import style0 from "./tabSelectNew.vue?vue&type=style&index=0&id=2f8c8d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports